import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ModuleBlock } from './ModuleBlock';

export function SortableModuleBlock({ module, isLocked, showConnector, isDragging }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ 
    id: module.id,
    disabled: isLocked
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1, // Hide the original when dragging
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <ModuleBlock
        module={module}
        isDragging={false}
        isLocked={isLocked}
        showConnector={showConnector}
      />
    </div>
  );
}